<template>
  <div class="screen screen__home screen__background-card">
    <div class="page--container">
      <div class="page--section">
        <el-card class="card card__login">
          <header class="card__header">
            <h1 class="h2 card__title">Product Knowledge Portal</h1>
            <p class="card__paragraph">{{ $t('pageDescriptionHome') }}</p>
          </header>
          <log-in-form></log-in-form>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import LogInForm from '@/components/LogInForm.vue';

export default {
  name: 'Login',
  components: {
    'log-in-form': LogInForm
  }
}
</script>

<style lang="scss" scoped>
.card__paragraph {
  font-size: 14px;
  margin: 0 0 10px;
  text-align: center;
}

.card__header {
  position: relative;
  text-align: center;
}
</style>
